import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faAmbulance,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowCircleDown,
  faArrowCircleUp,
  faArrowDown,
  faArrowRight,
  faArrowsAltV,
  faArrowUp,
  faArrowUpRightFromSquare,
  faAtlas,
  faBan,
  faBars,
  faBell,
  faBellSlash,
  faBriefcase,
  faBuilding,
  faBullseye,
  faBusAlt,
  faCalculator,
  faCalendarCheck,
  faCampground,
  faCaretSquareLeft,
  faCarSide,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronRight,
  faClipboardCheck,
  faCog,
  faComment,
  faCommentDollar,
  faCommentMedical,
  faComments,
  faCommentsDollar,
  faCopy,
  faCube,
  faCubes,
  faDollarSign,
  faDoorClosed,
  faDownload,
  faEdit,
  faEnvelope,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileContract,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePowerpoint,
  faFilter,
  faFireAlt,
  faFlagCheckered,
  faForward,
  faFunnelDollar,
  faFutbol,
  faGift,
  faGripLines,
  faHandHoldingDollar,
  faHandHoldingUsd,
  faHandPaper,
  faHandshake,
  faHandSparkles,
  faHardHat,
  faHeadset,
  faHeartCrack,
  faHome,
  faHospitalSymbol,
  faHourglassEnd,
  faHouseChimneyMedical,
  faImage,
  faInfoCircle,
  faKey,
  faLaptopMedical,
  faLevelDownAlt,
  faLevelUpAlt,
  faLink,
  faLock,
  faLongArrowAltDown,
  faMagnifyingGlassDollar,
  faMaximize,
  faMinimize,
  faMobileScreen,
  faMoneyBillAlt,
  faMoneyBillWave,
  faMoneyCheck,
  faMoneyCheckAlt,
  faMotorcycle,
  faPaintRoller,
  faPaperPlane,
  faPen,
  faPencilAlt,
  faPenNib,
  faPeopleGroup,
  faPercentage,
  faPersonCircleExclamation,
  faPhone,
  faPiggyBank,
  faPlane,
  faPlus,
  faPlusSquare,
  faPowerOff,
  faPrint,
  faProjectDiagram,
  faQuestionCircle,
  faRedo,
  faRedoAlt,
  faReply,
  faRightFromBracket,
  faRobot,
  faRotateLeft,
  faSackDollar,
  faSchool,
  faScissors,
  faScroll,
  faSearch,
  faSearchPlus,
  faShare,
  faShieldAlt,
  faShip,
  faShippingFast,
  faShoePrints,
  faShoppingBag,
  faSign,
  faSkull,
  faSms,
  faSortDown,
  faSpinner,
  faSprayCanSparkles,
  faSquareMinus,
  faStar,
  faStethoscope,
  faStickyNote,
  faStopwatch,
  faStopwatch20,
  faStore,
  faStreetView,
  faSync,
  faTasks,
  faThList,
  faTicketAlt,
  faTimes,
  faTrash,
  faTrashAlt,
  faTruckMoving,
  faUndo,
  faUnlink,
  faUnlock,
  faUpload,
  faUser,
  faUserCircle,
  faUserEdit,
  faUserFriends,
  faUserInjured,
  faUserLock,
  faUserNinja,
  faUserNurse,
  faUserPlus,
  faUsers,
  faUserShield,
  faUserSlash,
  faUserTag,
  faUserTimes,
  faUtensils,
  faVirus,
  faWallet,
  faWind,
  faQrcode,
  faPlaneCircleExclamation,
  faCaretUp,
  faCoins,
  faXmark,
  faEquals,
  faSlash,
  faCommentDots,
  faExclamation,
  faPaw,
  faBomb,
  faPlay,
  faUserTie,
  faCaretDown,
  faCommentAlt,
  faSquareCheck,
  faListUl,
  faCodeBranch,
  faRepeat,
  faTurnDown,
  faPenToSquare,
  faBookmark,
  faMagnifyingGlass,
  faCar,
  faHorseHead
} from '@fortawesome/free-solid-svg-icons'

import {faStripe, faWhatsapp} from '@fortawesome/free-brands-svg-icons'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

const fa = [
  faAmbulance,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowCircleDown,
  faArrowCircleUp,
  faArrowDown,
  faArrowRight,
  faArrowUp,
  faArrowUpRightFromSquare,
  faArrowsAltV,
  faAtlas,
  faBan,
  faBell,
  faBellSlash,
  faBriefcase,
  faBuilding,
  faBusAlt,
  faCalculator,
  faCalendarCheck,
  faCampground,
  faCarSide,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronRight,
  faClipboardCheck,
  faCog,
  faComment,
  faCommentDollar,
  faCommentMedical,
  faComments,
  faCommentsDollar,
  faCopy,
  faCube,
  faDollarSign,
  faDoorClosed,
  faDownload,
  faEdit,
  faEnvelope,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePowerpoint,
  faFilter,
  faFireAlt,
  faFlagCheckered,
  faForward,
  faFunnelDollar,
  faFutbol,
  faGift,
  faGripLines,
  faHandHoldingUsd,
  faHandPaper,
  faHandSparkles,
  faHandshake,
  faHardHat,
  faHeadset,
  faHeartCrack,
  faHome,
  faHospitalSymbol,
  faHourglassEnd,
  faHouseChimneyMedical,
  faInfoCircle,
  faLaptopMedical,
  faLevelDownAlt,
  faLevelUpAlt,
  faLink,
  faLock,
  faLongArrowAltDown,
  faMagnifyingGlassDollar,
  faMaximize,
  faMinimize,
  faMoneyBillAlt,
  faMoneyBillWave,
  faMoneyCheck,
  faMoneyCheckAlt,
  faMotorcycle,
  faPaintRoller,
  faPaperPlane,
  faPen,
  faPenNib,
  faPencilAlt,
  faPercentage,
  faPersonCircleExclamation,
  faPhone,
  faPiggyBank,
  faPlane,
  faPlus,
  faPlusSquare,
  faPowerOff,
  faPrint,
  faProjectDiagram,
  faQuestionCircle,
  faRedo,
  faRedoAlt,
  faReply,
  faRotateLeft,
  faSchool,
  faScissors,
  faRightFromBracket,
  faSackDollar,
  faScroll,
  faSearch,
  faShare,
  faShieldAlt,
  faShip,
  faShippingFast,
  faShoePrints,
  faShoppingBag,
  faSign,
  faSkull,
  faSms,
  faSpinner,
  faSprayCanSparkles,
  faSquareMinus,
  faStar,
  faStethoscope,
  faStickyNote,
  faStopwatch,
  faStopwatch20,
  faStore,
  faStreetView,
  faStripe,
  faSync,
  faTasks,
  faThList,
  faTicketAlt,
  faTimes,
  faTrash,
  faTrashAlt,
  faTruckMoving,
  faUndo,
  faUnlink,
  faUnlock,
  faUpload,
  faUser,
  faUserCircle,
  faUserEdit,
  faUserFriends,
  faUserInjured,
  faUserLock,
  faUserNinja,
  faUserNurse,
  faUserPlus,
  faUserShield,
  faUserSlash,
  faUserTag,
  faUserTimes,
  faUsers,
  faUtensils,
  faVirus,
  faWallet,
  faWhatsapp,
  faWind,
  faEyeSlash,
  faCaretSquareLeft,
  faFileContract,
  faSortDown,
  faRobot,
  faKey,
  faMobileScreen,
  faHandHoldingDollar,
  faBars,
  faSearchPlus,
  faPeopleGroup,
  faBullseye,
  faCubes,
  faImage,
  faQrcode,
  faPlaneCircleExclamation,
  faCaretUp,
  faCoins,
  faXmark,
  faEquals,
  faSlash,
  faCommentDots,
  faExclamation,
  faPaw,
  faBomb,
  faPlay,
  faUserTie,
  faCaretDown,
  faCommentAlt,
  faSquareCheck,
  faListUl,
  faCodeBranch,
  faRepeat,
  faTurnDown,
  faPenToSquare,
  faBookmark,
  faMagnifyingGlass,
  faCar,
  faHorseHead
]

fa.some(icon => {
  library.add(icon)
})


Vue.component('font-awesome-icon', FontAwesomeIcon)
